export const VUE_APP_SEVERENV = ''